export const neutral = {
    100: '#FFFFFF',
    98: '#F5FAFF',
    95: '#EBF2F8',
    90: '#DCE3E9',
    80: '#C0C7CD',
    70: '#A5ACB2',
    60: '#8A9297',
    50: '#71787D',
    40: '#585F64',
    30: '#40484D',
    20: '#2A3136',
    10: '#151D21',
    0: '#000000',
};
export default neutral;
